import { render, staticRenderFns } from "./putOnRecord.vue?vue&type=template&id=f52f6680&scoped=true"
import script from "./putOnRecord.vue?vue&type=script&lang=js"
export * from "./putOnRecord.vue?vue&type=script&lang=js"
import style0 from "./putOnRecord.vue?vue&type=style&index=0&id=f52f6680&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52f6680",
  null
  
)

export default component.exports